import { useTenant } from '@emerald-works-nova/auth'
import { useSelector } from 'react-redux'
import { accelerateSlice } from '../reducers'
import consts from '../consts'

const LICENSED = 'licensed'

/**
 * Whether the current user can see Skills Accelerator (PENG-3753).
 *
 * - Tenant without Accelerate: never.
 * - Unrestricted tenant (no licensing mode, today's behaviour): every user,
 *   decided straight from the tenant so nothing waits on a request.
 * - Licensed tenant: only users with a licence. The server decides through
 *   accelerateGetAccess, a licence check that does not wait for the SA status
 *   (which pulls progress from SCORM Cloud). Until it answers the user is
 *   treated as not having access, so SA never flashes for someone without a
 *   licence. A failed check also hides it; the backend guards every action
 *   regardless.
 *
 * `useProducts().hasAccelerateAccess` stays tenant-level on purpose: it drives
 * the reporting pages, which admins see without holding a licence.
 * @returns {{hasAccess: boolean, isResolved: boolean}} Access, and whether it is known yet
 */
const useAccelerateAccess = () => {
  const tenant = useTenant()
  const access = useSelector(accelerateSlice.selectors.selectAccess)

  const isTenantEnabled = tenant?.pk !== consts.DEFAULT_CLUB_PK && tenant?.features?.accelerate?.enabled === true
  if (!isTenantEnabled) return { hasAccess: false, isResolved: true }

  const isLicensed = tenant.features.accelerate.licensing?.mode === LICENSED
  if (!isLicensed) return { hasAccess: true, isResolved: true }

  if (access.isLoading) return { hasAccess: false, isResolved: false }
  if (access.hasError) return { hasAccess: false, isResolved: true }

  return { hasAccess: access.hasAccess, isResolved: true }
}

export default useAccelerateAccess
